/* Vestidor IA (Hagda) — fuente: C:\Claude\hagda-vestidor\nucleo\tienda\hagda-vestidor.js (igual para todas las marcas) */
(function () {
  'use strict';
  var LADO_MAX = 1024;
  // Mensajes de espera por defecto; cada marca manda los suyos en data-mensajes (marca.json → textos.cargando).
  var MENSAJES_BASE = ['Preparando tu prueba…', 'Cuidando los detalles…', 'Casi listo…'];
  var cache = {}; // hash|handle → imagen (solo en memoria: no guardamos fotos en el navegador)

  function $(root, sel) { return root.querySelector(sel); }

  function mostrar(root, paso) {
    root.querySelectorAll('[data-hv-paso]').forEach(function (el) { el.hidden = el.getAttribute('data-hv-paso') !== paso; });
  }

  // Reduce la foto a 1024 px de lado mayor y la pasa a JPEG. El navegador ya corrige la orientación EXIF.
  function prepararFoto(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        var k = Math.min(1, LADO_MAX / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * k); c.height = Math.round(h * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve({ dataUrl: c.toDataURL('image/jpeg', 0.86), ancho: c.width, alto: c.height });
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('formato')); };
      img.src = url;
    });
  }

  function sha256(texto) {
    if (!window.crypto || !crypto.subtle) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(texto)).then(function (buf) {
      return Array.from(new Uint8Array(buf)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    });
  }

  // Atribución: el atributo del carrito viaja al pedido (note_attributes). Sin datos personales.
  function marcarCarrito(handle) {
    try {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var previo = (cart.attributes && cart.attributes['Vestidor IA']) || '';
        var lista = previo ? previo.split(', ') : [];
        if (lista.indexOf(handle) === -1) lista.push(handle);
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Vestidor IA': lista.slice(-10).join(', ') } }),
        });
      }).catch(function () {});
    } catch (e) {}
  }

  function evento(nombre, datos) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos); } catch (e) {}
  }

  function iniciar(root) {
    var modal = $(root, '[data-hv-modal]');
    var archivo = $(root, '[data-hv-archivo]');
    var campoEmail = $(root, '[data-hv-email]');
    var aviso = $(root, '[data-hv-aviso]');
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var estado = $(root, '[data-hv-estado]');
    var handle = root.getAttribute('data-handle');
    var endpoint = root.getAttribute('data-endpoint');
    var MENSAJES = MENSAJES_BASE;
    try { var m = JSON.parse(root.getAttribute('data-mensajes') || 'null'); if (Array.isArray(m) && m.length) MENSAJES = m; } catch (e) {}
    var ultima = null;
    var timer = null;
    var barra = $(root, '[data-hv-barra]');
    var relleno = $(root, '[data-hv-relleno]');
    var cuadro = null;

    // Barra de progreso ESTIMADA: la IA no reporta avance. Sube rápido al principio y se acerca al 92% sin
    // llegar (curva exponencial, τ = 7 s: ~80% a los 13 s, ~90% a los 30 s). El 100% solo al tener la imagen.
    function pintar(p) {
      if (!relleno) return;
      relleno.style.transform = 'scaleX(' + (p / 100) + ')';
      barra.setAttribute('aria-valuenow', Math.round(p));
    }
    function progresoIniciar() {
      cancelAnimationFrame(cuadro);
      var t0 = performance.now();
      pintar(0);
      (function paso(ahora) {
        pintar(92 * (1 - Math.exp(-(ahora - t0) / 7000)));
        cuadro = requestAnimationFrame(paso);
      })(t0);
    }
    function progresoParar() { cancelAnimationFrame(cuadro); clearInterval(timer); }
    function progresoTerminar(listo) {
      progresoParar();
      pintar(100);
      setTimeout(listo, 320); // deja ver la barra completa antes de mostrar la foto
    }

    $(root, '[data-hv-abrir]').addEventListener('click', function () {
      mostrar(root, ultima ? 'resultado' : 'inicio');
      modal.showModal();
      evento('hagda_vestidor_abierto', { handle: handle });
    });
    $(root, '[data-hv-cerrar]').addEventListener('click', function () { modal.close(); });

    // El correo es obligatorio: sin él no se abre el selector de foto (ahí mandamos su imagen).
    function correoValido() {
      var ok = EMAIL_RE.test((campoEmail.value || '').trim());
      aviso.hidden = ok;
      if (!ok) { aviso.textContent = 'Escribe tu correo para continuar.'; campoEmail.focus(); }
      return ok;
    }
    $(root, '[data-hv-elegir]').addEventListener('click', function (e) {
      if (e.target === archivo) return;
      if (!correoValido()) e.preventDefault();
    });
    campoEmail.addEventListener('input', function () { if (!aviso.hidden && EMAIL_RE.test(campoEmail.value.trim())) aviso.hidden = true; });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });

    root.querySelectorAll('[data-hv-otra]').forEach(function (b) {
      b.addEventListener('click', function () { archivo.value = ''; mostrar(root, 'inicio'); archivo.click(); });
    });

    $(root, '[data-hv-comprar]').addEventListener('click', function () {
      modal.close();
      var form = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
      if (form) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); form.focus({ preventScroll: true }); }
    });

    $(root, '[data-hv-compartir]').addEventListener('click', function () {
      if (!ultima) return;
      fetch(ultima).then(function (r) { return r.blob(); }).then(function (blob) {
        var file = new File([blob], 'mi-' + handle + '.png', { type: blob.type || 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          return navigator.share({ files: [file], title: document.title, url: location.href.split('?')[0] });
        }
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob); a.download = file.name;
        document.body.appendChild(a); a.click(); a.remove();
      }).catch(function () {});
    });

    function error(msg) {
      progresoParar();
      $(root, '[data-hv-error]').textContent = msg || 'No pudimos generar tu imagen. Intenta con otra foto.';
      mostrar(root, 'error');
    }

    archivo.addEventListener('change', function () {
      var f = archivo.files && archivo.files[0];
      if (!f) return;
      if (!/^image\//.test(f.type) && !/\.(jpe?g|png|webp|heic)$/i.test(f.name)) return error('Sube una foto en JPG o PNG.');
      mostrar(root, 'cargando');
      var i = 0; estado.textContent = MENSAJES[0];
      clearInterval(timer);
      progresoIniciar();
      timer = setInterval(function () { i = Math.min(i + 1, MENSAJES.length - 1); estado.textContent = MENSAJES[i]; }, 6000);

      var foto;
      prepararFoto(f).then(function (r) {
        foto = r;
        return sha256(r.dataUrl);
      }).then(function (hash) {
        var llave = hash + '|' + handle;
        if (hash && cache[llave]) return { ok: true, imagen: cache[llave], llave: llave };
        evento('hagda_vestidor_enviado', { handle: handle });
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            handle: handle, foto: foto.dataUrl, ancho: foto.ancho, alto: foto.alto, photo_hash: hash,
            email: campoEmail.value.trim().toLowerCase(), novedades: !!($(root, '[data-hv-novedades]') || {}).checked,
            website: ($(root, '[data-hv-hp]') || {}).value || '',
          }),
        }).then(function (r) {
          return r.json().catch(function () { return { ok: false }; });
        }).then(function (d) { d.llave = llave; return d; });
      }).then(function (d) {
        if (d && d.error === 'email') { progresoParar(); mostrar(root, 'inicio'); aviso.textContent = d.mensaje; aviso.hidden = false; return; }
        if (!d || !d.ok || !d.imagen) return error(d && d.mensaje);
        cache[d.llave] = d.imagen;
        ultima = d.imagen;
        $(root, '[data-hv-img]').src = d.imagen;
        progresoTerminar(function () {
          mostrar(root, 'resultado');
          marcarCarrito(handle);
          evento('hagda_vestidor_resultado', { handle: handle });
        });
      }).catch(function (e) {
        error(e && e.message === 'formato'
          ? 'No pudimos leer esa foto. Si es de iPhone, elígela desde Fotos o toma una nueva.'
          : 'Se perdió la conexión. Intenta de nuevo.');
      });
    });
  }

  function arrancar() { document.querySelectorAll('[data-hv]').forEach(function (r) { if (!r.__hv) { r.__hv = 1; iniciar(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
